const inputs = document.querySelectorAll('.input')

inputs.forEach(input => {
	const toggle = input.querySelector('.togglePassword')
	const field = input.querySelector('input')
	if (toggle) {
		toggle.addEventListener('click', () => {
			if (field.type === 'password') {
				field.type = 'text'
			} else {
				field.type = 'password'
			}
		})
	}
})
